import { batch } from 'react-redux';
import { get } from 'lodash';
import template from 'url-template';

import awsHeader from '../helpers/awsAuth';
import { getErrorMessage } from '../helpers/errors';
import { handleNetworkError } from './applicationMessageActions';
import k2aBaseApi from '../apis/key2act';

import {
    EQUIPMENT_TYPES_LOAD_BEGIN,
    EQUIPMENT_TYPES_LOAD_END,
    EQUIPMENT_TYPES_LOAD_ERROR,
    FETCH_EQUIPMENT_TYPES
} from '../actions/actionTypes';

const DEFAULT_LIMIT = 10000;
const EquipmentTypesUrl = template.parse('/equipment-types{?limit}');

export const fetchEquipmentTypes = (options = {}) => async (dispatch, getState) => {
    options.limit || (options.limit = DEFAULT_LIMIT);
    try {
        const header = await awsHeader();
        dispatch(beginLoading());
        const response = await k2aBaseApi.get(
            EquipmentTypesUrl.expand(options),
            header
        );
        const payload = get(response, 'data.data', []);
        dispatch({
            type: FETCH_EQUIPMENT_TYPES,
            payload
        });
    } catch (error) {
        batch(() => {
            dispatch(errorLoading(getErrorMessage(error)));
            dispatch(handleNetworkError(error));
        });
    } finally {
        dispatch(endLoading());
    }
};

const beginLoading = () => ({
    type:    EQUIPMENT_TYPES_LOAD_BEGIN,
    payload: null
});

const endLoading = () => ({
    type:    EQUIPMENT_TYPES_LOAD_END,
    payload: null
});

const errorLoading = (error) => ({
    type:    EQUIPMENT_TYPES_LOAD_ERROR,
    payload: error
});
